import { ACTION_TYPES } from "../../actions/common/LoginActions"
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
const initialState = {
    list: [],
    isAuthenticated: false,
    token: '',
    language: 'es-MX',
    role: []
}
const reducer = (state = initialState, action) => {

    switch (action.type) {
        case ACTION_TYPES.LOGIN:
            var tokenData = getDataUser(action.payload.data.access_token)
            return {
                ...state,
                list: [action.payload],
                isAuthenticated: true,
                token: action.payload.data.access_token,
                role: tokenData.role.split(",")
            }
        case ACTION_TYPES.TOKEN_EXPIRED:
            return {
                ...state,
                list: [],
                isAuthenticated: false,
                token: '',
                role: []
            }
        default:
            return state
    }
}

const getDataUser = (token) => {
    if (token) {
        var base64Url = token.split('.')[1]
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(c => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join(''))
        return JSON.parse(jsonPayload)
    }
}

const persistConfig = {
    key: 'login',
    storage,
}

const LoginReducer = persistReducer(persistConfig, reducer);

export default LoginReducer